<template>
  <div>
    <div class="flex justify-between">
      <H2 class="mb-4 mt-8 text-grey">Bookings for: {{ venueDetails.name }}</H2>
      <div class="flex">
        <label class="mr-2 mb-4 mt-auto">Floorplan</label>
        <vs-switch class="mb-4 mt-auto" v-model="floorplan" />
      </div>
    </div>
    <div class="flex justify-between space-x-2">
      <div>
        <vs-collapse>
          <vs-collapse-item disabled v-if="!obsInfo || obsInfo.length === 0">
            <div slot="header">Obs Info - nothing to show</div>
          </vs-collapse-item>
          <vs-collapse-item v-if="obsInfo && obsInfo.length > 0">
            <div slot="header">Obs Info</div>
            <ul>
              <li
                v-for="(obsInfoItem, index) in obsInfo"
                :key="'obsInfoItem' + index"
              >
                {{ obsInfoItem.key + ": " + obsInfoItem.value }}
              </li>
            </ul>
          </vs-collapse-item>
        </vs-collapse>
       
      </div>
      
      <div>
        <vs-button
          class="add-booking-button"
          @click="handleAddBookingClick()"
          v-if="
            $AuthService.hasPermissionForActiveVenue(
              'vp.vp.booking.createbookings'
            )
          "
          >Add booking</vs-button
        >
      </div>
      
    </div>
     <div
          style="
            background-color: rgb(255 212 134) !important;
            color: rgb(139 93 10) !important;
          "
          v-for="venueNote in venueNotes"
          :key="venueNote.id"
          class="
            bg-warning bg-yellow-100
            opacity-80
            p-4
            rounded
            mt-2
            
            text-yellow-900 text-sm
            shadow-lg
          "
        >
          <p>
            <span class="font-bold">
              {{ formatVenueNoteDate(venueNote) }}
            </span>
            - {{ getUserName(venueNote) }}
          </p>
          <p><pre>{{ venueNote.message }}</pre></p>
        </div>
    <hr
      class="my-2"
      :class="venueNotes ? 'mt-4' : ''"
      style="
        border-top: 2px dotted #e3e3e3;
        border-bottom: none;
        border-left: none;
        border-right: none;
        
      "
    />
    <div v-if="isLoadingBookings">
      <p class="opacity-60">Finding bookings</p>
      <span class="flex h-12 w-12 mx-auto mt-5">
        <span
          class="
            animate-ping
            absolute
            inline-flex
            h-12
            w-12
            rounded-full
            bg-primary
            opacity-75
          "
        ></span>
        <span
          class="relative inline-flex rounded-full h-12 w-12 bg-primary"
        ></span>
      </span>
    </div>
    <div v-if="!isLoadingBookings">
      <div
        v-if="!floorplan"
        class="pl-12 p-6 pt-4 pr-0"
        style="margin-left: -3rem"
      >
        <div
          v-for="(enhBooking, index) in filterBookings(enhancedBookings)"
          :key="index"
          class="
            bg-white
            shadow-lg
            mb-4
            rounded-lg
            flex
            justify-between
            cursor-pointer
          "
          @click="$refs.popupEditBooking.show(enhBooking)"
        >
          <div class="p-6 px-8">
            <h4>
              {{
                enhBooking.reservedTable
                  ? enhBooking.reservedTable.name
                  : "No table"
              }}
              - {{ BOOKING_STATE.nameof(enhBooking.booking.bookingState) }}
            </h4>
            <div class="flex" v-if="enhBooking.event">
              <vs-chip color="blue">
                EVENT: {{ enhBooking.event.eventName }}
              </vs-chip>
            </div>
            <p class="text-grey">
              <span class="text-primary">{{
                enhBooking.bookingCustomer
                  ? enhBooking.bookingCustomer.name
                  : "No customer added"
              }}</span>
              <span class="mr-2">
              - {{ enhBooking.booking.guestCount }} guests - arrival:
              {{ formattedArrivalDate(enhBooking.booking) }}
              </span>
              <span
                class="tag-badge"
                v-if="enhBooking.booking.getThemeTag()"
                >{{ getBookingTagTranslation(enhBooking.booking.getThemeTag()) }}</span
              >
            </p>
          </div>
          <div
            class="rounded-r-lg p-6 "
            style="background-color: #f0f2f4 !important; min-width: 10rem; width:10rem "
          >
            <p class="m-0 text-grey">
              <small>
                {{ getTradingStatus(enhBooking.booking) }}
              </small>
            </p>
          </div>
        </div>
        <div v-if="filterBookings(enhancedBookings) && filterBookings(enhancedBookings).length === 0">
          <p class="text-grey" v-if="date">
            No bookings for {{ date.getDate() }}/{{ date.getMonth() + 1 }}
          </p>
          <p class="text-grey" v-else>No date selected</p>
        </div>
      </div>
      <div v-if="floorplan">
        <div
          v-if="!loadingFloorplan"
          class="relative"
          style="height: 600px; border: solid 1px #dddddd"
        >
          <floorplan-canvas
            :leftOffset="180"
            ref="floorplancanvas"
            @onBookingClick="$refs.popupEditBooking.show($event)"
            @onTableClick="
              $refs.popupTableDetails.show($event, handleAddBookingClick)
            "
          ></floorplan-canvas>
          <div
            class="shadow-lg p-4 rounded absolute overflow-auto"
            style="
              top: 8px;
              left: 8px;
              background: white;
              bottom: 8px;
              width: 13rem;
              font-size: 85%;
            "
          >
            <h6>Tables</h6>
            <p class="text-grey leading-relaxed mb-2" style="line-height: 1">
              <small>Click element to find it on floorplan</small>
            </p>
            <div
              v-for="(section, index) of this.setup.venueSections"
              :key="index"
              class="mb-4"
            >
              <h6
                class="mt-auto mr-8 cursor-pointer mb-1"
                @click="searchSection(section.id)"
              >
                {{ section.name }}
              </h6>
              <div
                style="
                  border-bottom: 1px solid #f3f3f3;
                  margin-bottom: 0.5rem;
                  margin-top: 0.25rem;
                "
              ></div>
              <div
                v-for="(table, index) of section.venueTables"
                :key="'table' + index"
                class="mb-2 py-1 px-2 rounded"
                :style="{
                  background:
                    table.booking ? '#ad0b0b1f' : 'inherit',
                }"
              >
                <div class="flex justify-between">
                  <p>
                    <span
                      class="cursor-pointer"
                      @click="searchTable(table.id)"
                      >{{ table.name }}</span
                    >
                    <feather-icon
                      v-if="table.isPlaced"
                      :icon="'CheckIcon'"
                      class="text-primary ml-4"
                      svgClasses="h-4 w-4 my-auto"
                    >
                    </feather-icon>
                  </p>
                  <div>
                    <p
                      class="cursor-pointer"
                      @click="$refs.popupEditBooking.show(table.booking)"
                      v-if="table.booking"
                    >
                      <small>Booked</small>
                    </p>
                    <p
                      class="cursor-pointer"
                      @click="
                        $refs.popupTableDetails.show(
                          table,
                          handleAddBookingClick
                        )
                      "
                      v-else
                    >
                      <small>{{
                        table.isReservedForWalkIns() ? "Walk-in" : "Available"
                      }}</small>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="loadingFloorplan">
          <p class="opacity-60">Loading floorplan</p>
          <span class="flex h-12 w-12 mx-auto mt-5">
            <span
              class="
                animate-ping
                absolute
                inline-flex
                h-12
                w-12
                rounded-full
                bg-primary
                opacity-75
              "
            ></span>
            <span
              class="relative inline-flex rounded-full h-12 w-12 bg-primary"
            ></span>
          </span>
        </div>
      </div>
    </div>
    <popup-add-booking
      ref="popupAddBooking"
      :venue-details="venueDetails"
      @booking-created="handleBookingCreated"
    />
    <popup-edit-booking
      ref="popupEditBooking"
      @booking-updated="handleBookingUpdated"
    />
    <popup-table-details
      @viewEndedBooking="$refs.popupEditBooking.show($event)"
      ref="popupTableDetails"
    />
  </div>
</template>

<script>
import { BOOKING_STATE } from "@/store/modules/marcom/data-model/bookings";
import { ACTIONS as VENUE_ACTIONS } from "@/store/modules/marcom/marcom";
import { ACTIONS as BOOKING_ACTIONS } from "@/store/modules/marcom/marcom-booking";

import { mapGetters } from "vuex";
import moment from "moment";
import * as _ from "lodash";
import PopupAddBooking from "../../../marcom/popups/PopupAddBooking.vue";
import PopupEditBooking from "../../../marcom/popups/PopupEditBooking.vue";
import PopupTableDetails from "../../../marcom/popups/PopupTableDetails.vue";
import FloorplanCanvas from "../../../marcom/components/FloorplanCanvas.vue";
import { BookingsByDateQuery } from "@/store/modules/marcom/data-model/bookings/queries-and-commands/bookings-by-date-query.js";
import { BOOKING_TYPE_TAG } from '../../../../../store/modules/marcom/data-model/bookings';

export default {
  components: {
    PopupAddBooking,
    PopupEditBooking,
    FloorplanCanvas,
    PopupTableDetails,
  },
  props: {
    venueNotes: Array,
    date: Date,
    venueDetails: Object,
  },
  data() {
    return {
      BOOKING_STATE,
      isLoadingBookings: false,
      pFloorplan: false,
      loadingFloorplan: false,
      setup: null,
      THEME_OTHER: "THEME:OTHER",
    };
  },
  async mounted() {
    this.searchBookings();
  },
  computed: {
    ...mapGetters({
      enhancedBookings: "marcomBooking/enhancedBookings",
      getBookingTagTranslation: "marcom/getBookingTagTranslation",
      activeVenueDetails: "marcom/activeVenue",
      user: "users/user",
    }),
    floorplan: {
      // getter
      get: function () {
        return this.pFloorplan;
      },
      // setter
      set: async function (newValue) {
        this.pFloorplan = newValue;
        if (newValue) {
          this.searchFloorplan();
        }
      },
    },
    obsInfo() {
      if (!this.venueDetails || !this.venueDetails.obsInfo) return [];

      return _.keys(this.venueDetails.obsInfo).map((key) => {
        return { key: key, value: this.venueDetails.obsInfo[key] };
      });
    },
  },
  watch: {
    date(val) {
      this.searchBookings();
    },
  },
  methods: {
    async searchBookings() {
      var bookingQuery = BookingsByDateQuery.create(
        this.date,
        this.venueDetails
      );

      await this.$store.dispatch(
        "marcomBooking/" + BOOKING_ACTIONS.SearchBookings,
        bookingQuery
      );
      this.searchFloorplan();
    },
    async searchFloorplan() {
      if (this.floorplan) {
        this.loadingFloorplan = true;

        var setupQuery = {
          venueDetailsId: this.venueDetails.id,
          dateTime: moment(this.date).hours(22).minutes(0).toJSON(),
        };

        this.setup = await this.$store.dispatch(
          "marcom/" + VENUE_ACTIONS.GetActiveSetup,
          setupQuery
        );
        if (this.setup) {
          var result = await this.$store.dispatch(
            "marcom/" + VENUE_ACTIONS.GetFloorplan,
            this.setup.id
          );
           if(this.isFloorPlanAvailable(result)){

           

          var setupTables = this.setup.venueSections
            .map((s) => s.venueTables)
            .flat();

          for (const table of result.tables) {
            var setupTable = setupTables.find((st) => st.id == table.tableId);
            if (setupTable) {
              table.name = setupTable.name;
              table.note = setupTable.note;
              table.isRoundTable = setupTable.isRoundTable;
              table.seatCount = setupTable.seatCount;
              table.isReservedForWalkIns = setupTable.isReservedForWalkIns();
              table.isActive = setupTable.isActive;
            }

            const allBookingsForTable = this.enhancedBookings.filter(
              (b) =>
                b.reservedTable.id === table.tableId ||
                (b.reservedTable.combinationTablePartIds !== null &&
                  b.reservedTable.combinationTablePartIds.filter(
                    (rt) => rt === table.tableId
                  ).length > 0)
            );

            table.booking = allBookingsForTable[0]
          
           
            const endedBookings = allBookingsForTable.filter((b) => 
               b.booking.tags.filter((tag) => tag == BOOKING_TYPE_TAG.Ended).length > 0
              )

            if (table.booking) {
              table.discardedBooking = endedBookings[endedBookings.length - 1]

               if (allBookingsForTable.length > endedBookings.length) {
                table.booking = allBookingsForTable.find((b)=> b.booking.tags.filter((tag) => tag == BOOKING_TYPE_TAG.Ended).length == 0)
              } else {
                table.booking = null
              }
              
            }
            
            setupTable.booking = table.booking;
       
          }

          var self = this;
          setTimeout(() => {
            self.$refs.floorplancanvas.setFloorplanModel(result);
          }, 100);
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Wait",
            text: "No setup found for this date",
          });
        }
        }
        this.loadingFloorplan = false;
      }
    },

    isFloorPlanAvailable(setup){

        return setup.tables.filter((t) => {
          return t.itemType != "NullTable"
        }).length > 0

    },

    getTradingStatus(booking) {
      if (!booking.orderLines || booking.orderLines.length == 0)
        return "No extra items added";
      var totalPrice = this.getTotalPrice(booking.orderLines);
      var totalQuantity = this.getTotalQuantity(booking.orderLines);
      var currency = booking.orderLines[0].unitPrice.currency;

      return (
        totalQuantity +
        " items (" +
        totalPrice.toFixed(2) +
        " " +
        currency +
        ")"
      );
    },
    getTotalQuantity(orderLines) {
      var tot = 0;
      for (const orderLine of orderLines) {
        tot += orderLine.quantity;
      }
      return tot;
    },
    getOrderlineTotalPrice(orderLine) {
      return orderLine.quantity * orderLine.unitPrice.value;
    },

    getTotalPrice(orderLines) {
      var tot = 0;
      for (const orderLine of orderLines) {
        tot += this.getOrderlineTotalPrice(orderLine);
      }
      return tot / 100;
    },
    async handleBookingUpdated() {
      await this.searchBookings();
    },
    handleAddBookingClick(table) {
      var date = moment(this.date).hours(22).minutes(0).toJSON();

      if (table) {
        //Find section
        var section = this.setup.venueSections.find(
          (s) => s.venueTables.filter((vt) => vt.id === table.id).length > 0
        );

        this.$refs.popupAddBooking.showWithTable(
          date,
          this.setup,
          section,
          table
        );
      } else {
        const isWalkIn = false;
        this.$refs.popupAddBooking.show(isWalkIn, date);
      }
    },
    async handleBookingCreated() {
      await this.searchBookings();
      this.$emit("trigger-booking-percentage-update");
    },
    // getTags(enhancedBooking) {
    //   if (enhancedBooking.booking.tags === null) return "";

    //   var result = enhancedBooking.booking.tags
    //     .map((bookingTag) => {
    //       if (bookingTag === null || bookingTag.indexOf("BOOKING_TYPE") >= 0)
    //         return "";
    //       var translation = this.tags.find((t) => t.tag === bookingTag);
    //       if (translation !== undefined)
    //         return translation.translations.find((t) => t.languageCode === "EN")
    //           .translation;

    //       if (_.startsWith(_.toUpper(bookingTag), `${this.THEME_OTHER}|`)) {
    //         return bookingTag.substring(`${this.THEME_OTHER}|`.length);
    //       }

    //       return bookingTag;
    //     })
    //     .filter((t) => t !== "")
    //     .join(", ");

    //   return result;
    // },

    searchSection(sectionId) {
      this.$refs.floorplancanvas.zoomToSection(sectionId);
    },
    searchTable(tableId) {
      this.$refs.floorplancanvas.zoomToTable(tableId);
    },
    formattedArrivalDate(booking) {
      return moment(booking.arrival).format("DD/MM/YYYY HH:mm");
    },
    filterBookings(bookings){    
      console.log("Bookings",bookings)
      console.log("avtive", this.activeVenueDetails)
            console.log("Venue",this.venueDetails)

        return bookings.filter((b) => b.booking.venueDetailsId.id == this.venueDetails.id)
    },
      formatVenueNoteDate(venueNote) {
      let noteMoment = moment.utc(venueNote.date);
      return noteMoment.format("DD-MM-YYYY");
    },
    getUserName(venueNote) {
      const theUser = this.user(venueNote.createdBy.id);
      return theUser
        ? `${theUser.firstName} ${theUser.lastName}`
        : "Unknown user";
    },
  },
};
</script>

<style lang="scss" scoped>
.tag-badge {
  display: inline-block;
  background: #b5b8bb50;
  color: #22222296;
  padding: 1px;
  padding-left: 4px;
  padding-right: 4px;
  border-radius: 4px;
}

.add-booking-button {
  width: 150px;
}

.vs-collapse::v-deep {
  padding: 0;

  .vs-collapse-item--header,
  .vs-collapse-item--content > .con-content--item {
    background-color: rgb(240, 242, 244);
    padding: 0;
  }
}
</style>
